// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"82355caf","404":"d7ae4d15","498":"61d5918d"}[chunkId] + ".chunk.js";
};